<template>
  <div>
    <v-row>
      <v-col class="d-flex pa-0">
        <!-- Search -->
        <strong class="mt-2 mr-2">動詞</strong>
        <v-text-field
          v-model="keyword"
          hide-details
          dense
          @keyup.enter="search"
          class="text-field-search mr-10"
          outlined
        />
        <v-btn color="primary" class="font-weight-black">{{
          $t("SEARCH")
        }}</v-btn>
        <v-spacer />
        <v-select
          class="select-record"
          hide-details
          :items="recordsPage"
          v-model="pagination.maxResultCount"
          dense
          outlined
        />
        <!-- Create General -->
        <v-btn
          :to="{
            name: 'Create Exercises Of Drill',
            params: $route.params,
            query: {
              no: pagination.pageCount + 1,
              page: pagination.page,
              maxPage: pagination.maxResultCount,
            },
          }"
          class="ml-2"
          v-text="$t('CREATE_NEW')"
          color="primary"
        />
      </v-col>
    </v-row>

    <!-- List Question -->
    <v-row>
      <v-layout class="mx-1 mt-5" child-flex>
        <v-data-table
          :headers="headers"
          max-height="60vh"
          fixed-header
          :items="listQuestion"
          :loading="loading"
          :items-per-page.sync="pagination.maxResultCount"
          :page.sync="pagination.page"
          :key="`data-${keyPagination}`"
          loading-text="読み込み中。。。待ってください。"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item.lead_sentence="{ item }">
            <span class="pre-wrap">{{ item.lead_sentence }}</span>
          </template>
          <template v-slot:item.name="{ item }">
            <span v-text="nameConvert(item)" />
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- Edit Question -->
            <v-icon
              size="22"
              @click="handleEditORViewDetailItem(item, 'Update')"
              >fas fa-pencil-alt</v-icon
            >

            <!-- View item -->
            <span class="mx-5">
              <v-icon
                size="22"
                @click="handleEditORViewDetailItem(item, 'Detail')"
                >fas fa-eye</v-icon
              >
            </span>

            <!-- Delete item for Question -->
            <DeleteIExercise :item="item" @resetList="handleGetListQuestion" />
          </template>
          <template v-slot:no-data>データがありません。</template>
        </v-data-table>
      </v-layout>
    </v-row>
    <v-row>
      <v-spacer />
      <BasePagination
        class="mt-5"
        v-show="listQuestion.length > 0"
        :initialPage="pagination.page"
        :pageCount="listQuestion.length"
        :dontSetInitialPage="true"
        ref="pagination"
        :key="`pagination-${keyPagination}`"
        :pageSize="pagination.maxResultCount"
        @changePage="changePage"
      />
    </v-row>
  </div>
</template>

<script>
import { getListQuestion } from "@/api/Question.api";
import BasePagination from "@/components/Pagination/BasePagination";
import DeleteIExercise from "@/views/drill/Exercises/DeleteIExercise.vue";
export default {
  store: ["formGeneral"],
  components: {
    BasePagination,
    DeleteIExercise,
  },
  data() {
    return {
      keyword: "",
      listQuestion: [],
      loading: false,
      defaultListQuestion: [],
      probleType: [
        { text: "全て", type: "all", key: "" },
        { text: "語彙・文法：4択", type: "write", key: "Choices" },
        { text: "語彙・文法：並び替え", type: "write", key: "Sort" },
        { text: "語彙・文法：ダイヤル入力", type: "write", key: "Conjugation" },
        { text: "漢字読み", type: "write", key: "Kanji" },
        { text: "短文聴解", type: "listen", key: "ShortSentences" },
        { text: "長文聴解", type: "listen", key: "LongSentences" },
        { text: "読解：4択", type: "read", key: "Comprehension" },
        { text: "読解：複数選択", type: "read", key: "MultiRead" },
      ],
      recordsPage: [5, 10, 20, 30, 100],
      pagination: {
        page: 1,
        pageCount: 0,
        maxResultCount: 30,
      },
      headers: [
        {
          text: "No.",
          align: "start",
          value: "no",
        },
        { text: "指示文", value: "lead_sentence" },
        { text: "動詞", value: "verb" },
        { text: this.$i18n.t("QUESTION"), value: "name", width: "30%" },
        {
          text: this.$i18n.t("ACTION"),
          value: "actions",
          align: "center",
          width: "150px",
        },
      ],
      keyPagination: 0,
    };
  },
  async mounted() {
    await this.handleGetListQuestion();
    const { page, maxPage } = this.$route.query;
    if (page && maxPage) {
      this.pagination.maxResultCount = Number(maxPage);
      this.pagination.page = Number(page);
      console.log("page: ", page, "maxPage: ", maxPage);
      this.keyPagination++;
    }
  },
  watch: {
    $route: async function () {
      await this.handleGetListQuestion();
    },
    "pagination.pageCount": function () {
      this.keyPagination++;
    },
    "pagination.maxResultCount": function () {
      this.keyPagination++;
    },
  },
  methods: {
    async handleGetListQuestion() {
      const { drillId } = this.$route.params;
      let params = {
        id: drillId,
      };
      this.loading = true;
      await getListQuestion(params)
        .then(({ result, totalCount }) => {
          this.loading = false;
          this.listQuestion = result;
          this.defaultListQuestion = result;
          this.pagination.pageCount = totalCount;
        })
        .catch(({ message }) => {
          this.loading = false;
          this.$toast.error(message);
        });
      this.checkTotalPage();
    },
    checkTotalPage() {
      const { totalPages } = this.$refs.pagination.$data.pager;
      const { page } = this.pagination;
      if (page > totalPages) {
        this.pagination.page = totalPages;
      }
    },
    async search() {
      await this.handleGetListQuestion();
      const { keyword } = this;
      let keywordSearch = keyword.toLowerCase();
      this.listQuestion = this.defaultListQuestion.filter((item) => {
        return item.verb.toString().toLowerCase().search(keywordSearch) > -1;
      });
      this.pagination.pageCount = this.listQuestion.length;
    },
    handleEditORViewDetailItem(item, key) {
      const { drillId } = this.$route.params;
      const { pagination } = this;
      if (key == "Update") {
        this.$router.push({
          name: "Update Exercises Of Drill",
          params: {
            drillId,
            exerciesID: item.Id,
          },
          query: {
            no: item.no,
            page: pagination.page,
            maxPage: pagination.maxResultCount,
          },
        });
      }
      if (key == "Detail") {
        this.$router.push({
          name: "Detail Exercises Of Drill",
          params: {
            drillId,
            exerciesID: item.Id,
          },
          query: {
            no: item.no,
            page: pagination.page,
            maxPage: pagination.maxResultCount,
          },
        });
      }
    },
    changePage(value) {
      console.log("------------");
      this.pagination.page = value;
    },
    nameConvert(item) {
      let unline = "";
      item.list_answer.answer[0].forEach(() => {
        unline += " __ ";
      });
      return `${item.list_answer.sentence_answer[0]} ${unline} ${item.list_answer.sentence_answer[1]}`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>